export default {
  '该图表是关联图表，已同时被其他仪表盘关联，对该图表的编辑操作将同时影响其所有已关联的图表': 'This chart is a linked chart and has been associated with other dashboards. Editing operations on this chart will affect all associated charts simultaneously.',
  暂无图表查看权限: 'No chart viewing permission',
  下钻到市: 'Drill to City',
  查看数据: 'View Data',
  '图表导出中，导出后的文件将通过飞书消息卡片进行通知': 'The chart is being exported. The exported file will be notified through the Feishu message card.',
  '图表配置异常，请编辑检查图表配置': 'The chart configuration is abnormal. Please check the chart configuration.',
  驾驶舱: 'Dashboard',
  仪表盘显隐设置: 'Dashboard Visibility Settings',
  取消图表关联: 'Unlink Chart',
  确定将所选图表取消与其它仪表盘内该图表的关联吗: 'Are you sure you want to unlink the selected chart from this and other dashboards',
  '取消关联后，将创建该图表的副本，且对该图表的后续操作将不影响其它仪表盘内已关联的图表': 'After unlinking, a copy of this chart will be created, and subsequent actions on this chart will not affect its linked versions in other dashboards',
  仅查看: 'View Only',
  添加仪表盘: 'Add Dashboard',
  新建仪表盘: 'Create Dashboard',
  复制仪表盘: 'Duplicate Dashboard',
  编辑仪表盘: 'Edit Dashboard',
  从图表库添加: 'Add from Chart Library',
  新建图表: 'Create Chart',
  筛选配置: 'Filter Configuration',
  全屏显示: 'Full Screen',
  '近7天(含今日)': 'Last 7 Days (Including Today)',
  '近7天(不含今日)': 'Last 7 Days (Excluding Today)',
  '近30天(含今日)': 'Last 30 Days (Including Today)',
  '近30天(不含今日)': 'Last 30 Days (Excluding Today)',
  '无新建仪表盘权限，请联系管理员': 'No permission to create dashboards. Please contact the administrator.',
  '可新建仪表盘，开始搭建你的数据驾驶舱': 'You can create dashboards. Start building your data dashboard.',
  '选择一个图表组件，开始搭建你的仪表盘': 'Select a chart component to start building your dashboard.',
  '快速插入柱状图、折线图、饼图等多种组件类型，直观展示数据，让业务动态一目了然': 'Quickly insert various component types such as bar charts, line charts, pie charts, etc., to visually display data and make business dynamics clear at a glance.',
  无新建图表权限: 'No permission to create charts.',
  请联系管理员: 'Please contact the administrator.',
  退出全屏: 'Exit Full Screen',
  暂无图表: 'No Charts Available',
  类型筛选: 'Type Filter',
  默认筛选日期: 'Default Date Filter',
  请选择默认筛选日期: 'Please select default date filter',
  请选择图表: 'Please select a chart',
  筛选字段: 'Filter Fields',
  '字段异常，请检查字段状态': 'If the field is abnormal, check the field status',
  '删除操作不可恢复，是否确定删除当前仪表盘': 'Deleting cannot be undone. Are you sure you want to delete the current dashboard?',
  退出后当前修改将失效: 'Changes will be lost if you exit.',
  确认退出: 'Confirm Exit',
  全部图表: 'All Charts',
  我创建的: 'Created by Me',
  我可编辑的: 'Editable by Me',
  全部图表类型: 'All Chart Types',
  柱状图: 'Bar Chart',
  折线图: 'Line Chart',
  饼图: 'Pie Chart',
  指标卡: 'Indicator Card',
  数据表: 'Data Table',
  地图: 'Map',
  请输入图表名称: 'Please enter chart name',
  图表名称: 'Chart Name',
  是否确定从当前仪表盘移除该图表: 'Are you sure you want to remove this chart from the current dashboard?',
  '删除操作不可恢复，是否确定删除当前图表': 'Deleting cannot be undone. Are you sure you want to delete this chart?',
  立即创建: 'Create Now',
  仪表盘名称: 'Dashboard Name',
  仪表盘名称是必填项: 'Dashboard name is required',
  请输入仪表盘名称: 'Please enter dashboard name',
  查看权限: 'View Permissions',
  请选择数据权限: 'Please select data permissions',
  公开: 'Public',
  私有: 'Private',
  部分人可见: 'Visible to Some',
  查看人员: 'Viewers',
  导出权限: 'Export Permissions',
  编辑权限: 'Edit Permissions',
  删除权限: 'Delete Permissions',
  权限设置: 'Permission Settings',
  图表库: 'Chart Library',

  创建图表: 'Create Chart',
  编辑图表: 'Edit Chart',
  复制图表: ' Copy Chart',
  数据来源: 'Data Source',
  请选择数据来源: 'Please Select Data Source',
  请选择对象: 'Please Select Object',
  '（异常）': ' (Abnormal)',
  数据范围: 'Data Range',
  请选择数据范围: ' Please Select Data Range',
  添加条件: 'Add Condition',
  图表类型: ' Chart Type',
  请选择图表类型: 'Please Select Chart Type',
  '请选择横轴(维度)': 'Please Select X-Axis (Dimension)',
  '请选择纵轴(指标)': 'Please Select Y-Axis (Measure)',
  '请选择扇形分组(维度)': 'Please Select Pie Sector Grouping (Dimension)',
  '请选择扇形数值(指标)': 'Please Select Pie Sector Value (Measure)',
  ' 请选择行(维度)': 'Please Select Row (Dimension)',
  '请选择列(指标)': 'Please Select Column (Measure)',
  请选择主指标: 'Please Select Primary Measure',
  请选择次指标: 'Please Select Secondary Measure',
  '1个维度': '1 Dimension',
  '0~10个维度': '0 to 10 Dimensions',
  '1个指标': '1 Measure',
  '1~10个指标': '1 to 10 Measures',
  '1~20个指标': '1 to 20 Measures',
  '0~5个指标': '0 to 5 Measures',
  '0~4个指标': '0 to 4 Measures',
  '横轴(维度)': ' X-Axis (Dimension)',
  '纵轴(指标)': ' Y-Axis (Measure)',
  '扇形分组(维度)': 'Pie Sector Grouping (Dimension)',
  '扇形数值(指标)': 'Pie Sector Value (Measure)',
  主指标: 'Primary Measure',
  次指标: 'Secondary Measure',
  '行(维度)': 'Row (Dimension)',
  '列(指标)': 'Column (Measure)',
  请选择字段: 'Please Select Field',
  分组聚合: 'Group and Aggregate',
  '0~1个分组': '0 to 1 Group',
  排序规则: 'Sorting Rule',
  请选择排序规则: 'Please Select Sorting Rule',
  应用: 'Apply',
  全部数据: 'All Data',
  条件范围数据: 'Conditional Data Range',
  更改数据源: 'Change Data Source',
  '更改数据源将清空当前图标配置，是否确认修改？': 'Changing data source will clear current chart settings, confirm modification?',
  提醒: 'Reminder',
  '该图表为关联图表，已同时被其它仪表盘关联，保存后将同步影响其它仪表盘下图表，是否确认保存？': ' This chart is linked to other dashboards. Saving will affect all linked charts on other dashboards, confirm save?',
  添加字段: ' Add Field',
  输入关键字搜索: 'Enter Keyword Search',
  '最多添加10个维度!': 'Maximum of 10 dimensions!',
  '最多添加1个维度!': ' Maximum of 1 dimension!',
  '最多添加10个指标!': 'Maximum of 10 measures!',
  '最多添加1个指标!': 'Maximum of 1 measure!',
  ' 最多添加20个指标!': 'Maximum of 20 measures!',
  '最多添加5个指标!': 'Maximum of 5 measures!',
  '最多添加4个指标!': 'Maximum of 4 measures!',
  '最多添加1个分组聚合字段!': 'Maximum of 1 group aggregation field!',
  升序: 'Ascending',
  降序: 'Descending',
  基础柱状图: 'Basic Bar Chart',
  堆积柱状图: 'Stacked Bar Chart',
  基础折线图: 'Basic Line Chart',
  平滑折线图: 'Smooth Line Chart',
  阶梯折线图: 'Stepped Line Chart',
  环形图: 'Doughnut Chart',
  求和: 'Sum',
  平均值: 'Average',
  计数: 'Count',
  最大值: 'Max',
  最小值: 'Min',
  年: 'Year',
  '年-季': 'Year-Quarter',
  '年-月': 'Year-Month',
  '年-月-日': 'Year-Month-Day',
  数字: 'Number',
  金额: 'Amount',
  百分比: 'Percentage',
  整数: 'Integer',
  保留1位小数: '1 Decimal Place',
  保留2位小数: '2 Decimal Places',
  保留3位小数: '3 Decimal Places',
  保留4位小数: '4 Decimal Places',
  保留5位小数: '5 Decimal Places',
  保留6位小数: '6 Decimal Places',
  保留7位小数: '7 Decimal Places',
  保留8位小数: '8 Decimal Places',
  '当前数据源有异常，请检查数据源状态和权限!': 'Current data source has an issue, please check data source status and permissions!',
  '当前横轴/指标字段有异常，请检查字段状态!': 'Current X-Axis/Measure field has an issue, please check field status!',
  '当前纵轴/指标字段有异常，请检查字段状态!': ' Current Y-Axis/Measure field has an issue, please check field status!',
  '当前次指标字段有异常，请检查字段状态!': 'Current secondary measure field has an issue, please check field status!',
  '当前分组聚合字段有异常，请检查字段状态!': 'Current group aggregation field has an issue, please check field status!',
  '当前排序字段有异常，请检查字段状态!': 'Current sorting field has an issue, please check field status!',
  图表字段: 'Chart Fields',
  请输入图表字段: 'Please Input Chart Fields',
  显示名称: 'Display Name',
  请输入显示名称: ' Please Input Display Name',
  汇总方式: 'Summary Method',
  请选择汇总方式: 'Please Select Summary Method',
  计算方式: 'Calculation Method',
  请选择计算方式: 'Please Select Calculation Method',
  格式: 'Format',
  请选择格式: 'Please Select Format',
  小数位数: 'Decimal Places',
  请选择小数位数: 'Please Select Decimal Places',
  图表基础信息: 'Chart Basics',
  图表标题: 'Chart Title',
  请输入图表标题: 'Please Input Chart Title',
  图表描述: 'Chart Description',
  请输入图表描述: 'Please Input Chart Description',
  主题色: 'Theme Color',
  图表主题: 'Chart Theme',
  请选择主题色: 'Please Select Theme Color',
  字体颜色与字号: 'Font Color and Size',
  横轴: 'X-Axis',
  横轴标题: 'X-Axis Title',
  请输入横轴标题: 'Please Input X-Axis Title',
  显示标签: 'Show Labels',
  标签位置: 'Label Position',
  纵轴: 'Y-Axis',
  纵轴标题: 'Y-Axis Title',
  图例位置: 'Legend Position',
  地图钻取: 'Map Drilldown',
  扇区样式: 'Sector Style',
  系列样式: 'Series Style',
  显示数据标签: 'Show Data Labels',
  数据标签位置: 'Data Label Position',
  数据标签字体颜色与字号: 'Data Label Font Color and Size',
  标签内容: 'Label Content',
  请选择标签内容: 'Please Select Label Content',
  '网格&刻度&轴线': 'Grid & Ticks & Axes',
  计算总结果: 'Calculate Total',
  垂直向上: 'Vertical Up',
  左起斜上: 'Diagonal Up from Left',
  横排: 'Horizontal',
  左起斜下: 'Diagonal Down from Left',
  垂直向下: 'Vertical Down',
  横轴网格线: 'X-Axis Grid Lines',
  横轴刻度: 'X-Axis Ticks',
  横轴轴线: 'X-Axis Axis Line',
  纵轴网格线: 'Y-Axis Grid Lines',
  纵轴刻度: 'Y-Axis Ticks',
  纵轴轴线: 'Y-Axis Axis Line',
  顶部: 'Top',
  左侧: 'Left',
  右侧: 'Right',
  底部: 'Bottom',
  隐藏: 'Hidden',
  跟随主题色: 'Follow Theme Color',
  自定义填充色: 'Custom Fill Color',
  外部: 'External',
  居中: 'Centered',
  内部: 'Internal',
  扇形类别: 'Pie Category',
  值: 'Value',
  不显示: 'Do Not Show',
  显示维度值: 'Show Dimension Value',
  显示主指标值: 'Show Primary Measure Value',
  钻取到省: 'Drilldown to Province',
  不允许钻取: 'No Drilldown Allowed',
  查看全部数据: 'View all data',
  '当前窗口区域过窄，无法添加图表': 'The current window area is too narrow to add a chart',
  '当前窗口过小，无法编辑。请调整窗口后再进行编辑操作': 'The current window is too small to edit. Please adjust the window and try editing again',
  '当前窗口区域过窄，无法添加图表。请调整窗口后再进行操作': 'The current window area is too narrow to add a chart. Please adjust the window and try again',
  '当前窗口过小，无法复制。请调整窗口后再进行复制操作': 'The current window is too small to copy. Please adjust the window and try copying again',
  柱状图类型: 'Bar Chart Type',
  折线图类型: 'Line Chart Type',
  饼图类型: 'Pie Chart Type',
  指标卡类型: 'Indicator Card Type',
  地图类型: 'Map Type',
  数据表类型: 'Data Table Type',
  自定义排序: 'Custom Sorting',
  '仪表盘设计有修改，是否保存': 'Dashboard design has been modified. Do you want to save it?',
  '你修改了仪表盘设计但没有保存，是否需要保存仪表盘设计并继续': 'You have modified the dashboard design without saving. Do you want to save the dashboard design and continue?',
  返回仪表盘设计: 'Return to Dashboard Design',
  不保存: 'Do Not Save',
  保存并继续: 'Save and Continue',
  取消勾选展示全部数据: 'Uncheck to Hide All Data',
  显示前: 'Show Top',
  条数据: 'Data Items'
};
